import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IAcceptAccountResultVm } from '../accept-account-result-vm.model';
import { IAcceptAccountIm } from '../accept-account-im.model';
@Injectable({ providedIn: 'root' })
export class AcceptAccountService {
  private readonly baseUrl: string;
  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/AcceptAccount`;
  }
  post(acceptAccountIm: IAcceptAccountIm): Observable<IAcceptAccountResultVm> {
    const headers = this.createHeaders();
    return this.http.post<IAcceptAccountResultVm>(this.baseUrl, acceptAccountIm, { headers });
  }
  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
